var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"thread"}},[(_vm.isReadyToGet)?_c('messages-list',{staticClass:"h-100",attrs:{"custom-send-message":_vm.customSendMessage,"load-more":_vm.getThreadMessages,"messages":_vm.computedMessages,"hidden-messages":_vm.computedHiddenMessages,"translations":_vm.translations}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f362835","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThreadMessages.vue
// module id = null
// module chunks = 